export const SEARCH_HOTEL_CUSTOMERS = `query SearchHotelCustomers($hotel_id: String!, $search_key: String!) {
    search_hotel_customers(hotel_id: $hotel_id, search_key: $search_key) {
      customer_id
      title
      name
      email
      phone
      mobile
      address
      preference
    }
  }`;
  